module.exports = __webpack_public_path__ + "img/99.e85de967.svg";